module.exports = __webpack_public_path__ + "media/1_3_1-3.7f2c8439.mp3";